import React from "react";
import { Check, ClipboardCopy } from "lucide-react";

export default function UpgradeModal({ couponCode, copied, onClaim, onCopy, onDecline, onContinue }) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/75 backdrop-blur-sm px-4" data-testid="upgrade-popup">
      <div className="w-full max-w-md rounded-3xl border border-pink-500/50 bg-gradient-to-br from-[#1a0710] to-[#121212] p-7">
        {!couponCode ? (
          <>
            <p className="text-xs uppercase tracking-widest text-pink-500 font-bold mb-2">Special offer</p>
            <h2 className="text-2xl font-extrabold tracking-tight">Upgrade to Signature Wash | Clay | Coat</h2>
            <p className="text-sm text-zinc-300 mt-3 leading-relaxed">You're getting <strong>$30 of free value</strong> — a complimentary exhaust tip + gas-cap clean added to your detail.</p>
            <div className="mt-6 flex flex-col gap-3">
              <button onClick={onClaim} className="bg-pink-600 hover:bg-pink-500 rounded-full py-3 font-bold" data-testid="upgrade-claim">Upgrade &amp; claim my free gift</button>
              <button onClick={onDecline} className="text-zinc-400 hover:text-white text-sm" data-testid="upgrade-decline">No thanks, keep Premium</button>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-2xl font-extrabold tracking-tight">You're upgraded! 🎉</h2>
            <p className="text-sm text-zinc-300 mt-3">Your packages are now Signature and your free exhaust tip + gas-cap clean is added. Here's your coupon code:</p>
            <div className="mt-4 flex items-center gap-2 rounded-xl border border-pink-500/50 bg-[#050505] p-3">
              <p className="flex-1 text-center text-2xl font-mono font-extrabold text-pink-500" data-testid="upgrade-code">{couponCode}</p>
              <button onClick={onCopy} className="rounded-lg bg-white/10 hover:bg-pink-600 px-3 py-2 text-xs font-semibold flex items-center gap-1 transition-colors" data-testid="upgrade-copy">{copied ? <><Check size={14} /> Copied</> : <><ClipboardCopy size={14} /> Copy</>}</button>
            </div>
            <button onClick={onContinue} className="mt-6 w-full bg-pink-600 hover:bg-pink-500 rounded-full py-3 font-bold" data-testid="upgrade-continue">Continue</button>
          </>
        )}
      </div>
    </div>
  );
}
